import React, { useEffect, useState, memo } from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import Popups from '../../components/Popup';
import AutoCompleteContainer from '../AutoComplete';
import { usePopupContext } from '../../contexts/PopupContext';

const PREFIX_BUYER = 'agreementLinking.';

const EMPTY_VALUE = {
  id: null,
  text: null,
};

const AgreementLinkPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const selectedAgreementCategory = props.popup.getIn(['props', 'selectedAgreementCategory']);
  const agreementCategories = props.popup.getIn(['props', 'agreementCategories']);
  const companyName = props.popup.getIn(['props', 'companyName']);
  const findBuyers = props.popup.getIn(['props', 'findBuyers']);
  const handleUpdateCompany = props.popup.getIn(['props', 'handleUpdateCompany']);
  const getCompanyRetainersByCompanyId = props.popup.getIn(['props', 'getCompanyRetainersByCompanyId']);
  const updateAgreementCategories = props.popup.getIn(['props', 'updateAgreementCategories']);

  const [agreementOptions, setAgreementOptions] = useState(List());
  const [agreementValue, setAgreementValue] = useState(EMPTY_VALUE);
  const [companyValue, setCompanyValue] = useState(EMPTY_VALUE);

  useEffect(() => {
    handleUpdateCompany({
      name: `${PREFIX_BUYER}buyerName`,
      value: '',
    });

    findBuyers({
      filter: companyName,
      page: 1,
      field: `${PREFIX_BUYER}buyerName`,
      afterSuccess: ({ response: { data } }) => {
        if (data.length === 0) return;

        handleUpdateCompany({
          name: `${PREFIX_BUYER}buyerName`,
          value: data[0].text,
        });

        setCompanyValue({
          ...data[0],
        });
      },
    });
  }, []);

  useEffect(() => {
    if (companyValue.id) {
      getCompanyRetainersByCompanyId({ companyId: companyValue.id });
    }
  }, [companyValue]);

  useEffect(() => {
    if (!companyValue.id) {
      return;
    }

    if (selectedAgreementCategory) {
      setAgreementValue({
        id: selectedAgreementCategory.get('linkedAgreementId'),
        text: selectedAgreementCategory.get('linkedAgreementName'),
      });
    }
  }, [selectedAgreementCategory, companyValue]);

  useEffect(() => {
    if (props.linkedCompanyRetainers) {
      setAgreementOptions(
        props.linkedCompanyRetainers.map(linkedCompanyRetainer => ({
          id: linkedCompanyRetainer.get('id'),
          text: linkedCompanyRetainer.get('contractualName'),
        })),
      );
    }
  }, [props.linkedCompanyRetainers]);

  const handleClose = () => {
    const updatedAgreementCategories = agreementCategories.map(agreementCategory => {
      const item = Map.isMap(agreementCategory) ? agreementCategory.toJS() : agreementCategory;

      return {
        ...item,
        children: item.children.map(child => {
          if (child.id === selectedAgreementCategory.get('id')) {
            return {
              ...child,
              linkedAgreementBuyerId: companyValue.id,
              linkedAgreementBuyerName: companyValue.text,
              linkedAgreementId: agreementValue.id,
              linkedAgreementName: agreementValue.text,
            };
          }

          return child;
        }),
      };
    });

    updateAgreementCategories(updatedAgreementCategories);
    closePopup();
  };

  const handleAgreementSuggestSelect = ({ id, text }) => {
    setAgreementValue({ id, text });
  };

  const handleBuyerSuggestChange = ({ name, value }) => {
    if (value === '') {
      setAgreementOptions(List());
      setCompanyValue(EMPTY_VALUE);
      setAgreementValue(EMPTY_VALUE);
    }

    return handleUpdateCompany({ name, value });
  };

  const handleBuyerSuggestSelect = ({ id, text }) => {
    setCompanyValue({ id, text });
  };

  const getBuyerSuggestions = () => (
    <AutoCompleteContainer
      idName={`${PREFIX_BUYER}buyerId`}
      inputProps={{
        name: `${PREFIX_BUYER}buyerName`,
        className: 'form-control',
        label: 'Buyer',
        tabIndex: -1,
      }}
      name={`${PREFIX_BUYER}buyerName`}
      onChange={handleBuyerSuggestChange}
      onFind={options => {
        findBuyers({
          ...options,
          field: `${PREFIX_BUYER}buyerName`,
        });
      }}
      onSelectCallback={handleBuyerSuggestSelect}
      rootPath={['targetCompany', 'buyer', 'retainer']}
      suggestionsName={`${PREFIX_BUYER}buyerSuggests`}
      valueName={`${PREFIX_BUYER}buyerName`}
    />
  );

  const getAgreementSuggestions = () => (
    <AutoCompleteContainer
      idName="agreement"
      inputProps={{
        name: 'agreement',
        className: 'form-control',
        label: 'Agreement',
        tabIndex: -1,
        autoComplete: 'off',
      }}
      loadable={false}
      name="agreement"
      onChange={() => undefined}
      onFind={() => undefined}
      onSelectCallback={handleAgreementSuggestSelect}
      suggestions={agreementOptions}
      value={agreementValue.text}
      valueName="agreement"
      suggestIfEmpty
    />
  );

  return (
    <Popups.AgreementLinkPopup
      isDisabled={!companyValue.id || !agreementValue.id}
      onClose={handleClose}
      suggestAgreement={getAgreementSuggestions()}
      suggestBuyer={getBuyerSuggestions()}
    />
  );
};

const mapStateToProps = state => ({
  linkedCompanyRetainers: state.targetCompany.buyer.retainer.get('linkedCompanyRetainers'),
});

export { AgreementLinkPopupContainer };
export default connect(mapStateToProps, null)(memo(AgreementLinkPopupContainer));
